import { User } from './auth.type';
import {
  BaremeIndemnisationValueChoice,
  BaremeRIIRoundChoice,
} from './procedure.type';
import { Subscription } from './subscription.type';

export enum OrganizationType {
  CABINET_AVOCAT = 'cabinet_avocat',
  ASSURANCE = 'assurance',
  FONDS_INDEMNISATION = 'fonds_indemnisation',
  MAGISTRATURE = 'magistrature',
  AUTRE = 'autre',
}

export enum OrganizationMemberRole {
  owner = 'organization_owner',
  admin = 'organization_admin',
  member = 'organization_member',
}

export interface OrganizationTemplate {
  storageName: string;
  type: 'cover' | 'body';
  filename: string;
  isSelected?: boolean;
}

export interface Organization {
  _id: string;
  name: string;
  type: OrganizationType;
  subscription: Subscription;
  members: OrganizationMember[];
  victimes: string[];
  forbidNonOrganizationEmails?: boolean;
  hideSensitiveFields?: boolean;
  createdAt: string;
  baremes?: OrganizationBaremes;
  templates?: OrganizationTemplate[];
}

export class OrganizationBaremes {
  baremeCapitalisationId?: string | null;
  baremeIndemnisationId?: string | null;
  baremeIndemnisationValueChoice?: BaremeIndemnisationValueChoice | null;
  baremeRIIId?: string | null;
  forfaitJourDFTP?: number | null;
  forfaitJourDFTT?: number | null;
  baremeRIIRoundAge?: BaremeRIIRoundChoice | null;
  baremeRIIRoundTauxDFP?: BaremeRIIRoundChoice | null;
  forfaitHoraireATPT?: number | null;
  averageDegree?: boolean;
}

export interface OrganizationMember
  extends Pick<User, '_id' | 'email' | 'firstName' | 'lastName'> {
  role: OrganizationMemberRole;
}

export type CreateOrganizationDto = Omit<
  Organization,
  '_id' | 'members' | 'victimes' | 'createdAt' | 'subscription'
>;
export type UpdateOrganizationDto = Partial<
  Omit<CreateOrganizationDto, 'type'>
>;
export type UpdateMemberRoleDto = {
  role: OrganizationMemberRole;
};
